import React, { useEffect, useRef, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Paper,
  Box,
  Divider,
  Container,
  Zoom,
  useScrollTrigger,
  Fab,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const TransactionHistory = ({ transactions, ...props }) => {
  // Dados simulados baseados na imagem
  const [showButton, setShowButton] = useState(false);
  const topRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Se a div do topo NÃO está visível, mostramos o botão
        setShowButton(!entry.isIntersecting);
      },
      { threshold: 0.1 }, // Dispara quando 10% da div sumir/aparecer
    );

    if (topRef.current) {
      observer.observe(topRef.current);
    }

    return () => {
      if (topRef.current) observer.unobserve(topRef.current);
    };
  }, []);

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      {/* Âncora para o scroll voltar aqui */}
      <div ref={topRef} style={{ height: "1px", width: "100%" }} />

      <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, px: 1 }}>
        Recentes
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid #e0e0e0",
          overflow: "hidden",
        }}
      >
        <List dense disablePadding>
          {transactions.map((item, index) => (
            <React.Fragment key={item._id}>
              <ListItem
                sx={{
                  py: 2,
                  px: 2,
                  p: 1,
                  // Barra lateral colorida baseada no tipo
                  borderLeft: `5px solid ${item.amount >= 0 ? "#2e7d32" : "#d32f2f"}`,
                  "&:hover": { bgcolor: "rgba(0,0,0,0.02)" },
                }}
              >
                {/* Lado Esquerdo: Título e Data */}
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      fontWeight="700"
                      sx={{ textTransform: "capitalize" }}
                    >
                      {item.description}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {item.createdAt}
                    </Typography>
                  }
                />

                {/* Lado Direito: Valor e Ícone */}
                <Box textAlign="right">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 0.5,
                    }}
                  >
                    {item.amount >= 0 ? (
                      <ArrowUpwardIcon
                        sx={{ fontSize: 14, color: "success.main" }}
                      />
                    ) : (
                      <ArrowDownwardIcon
                        sx={{ fontSize: 14, color: "error.main" }}
                      />
                    )}
                    <Typography
                      variant="body1"
                      fontWeight="800"
                      color={item.amount >= 0 ? "success.main" : "error.main"}
                    >
                      {item.amount >= 0 ? `+${item.amount}` : item.amount}
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mt: -0.5 }}
                  >
                    Pontos
                  </Typography>
                </Box>
              </ListItem>
              {index < transactions.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
      {/* BOTÃO FAB: O Zoom agora é controlado pelo estado 'showButton' */}
      <Zoom in={showButton}>
        <Box
          onClick={scrollToTop}
          sx={{ position: "fixed", bottom: 32, right: 32, zIndex: 9999 }}
        >
          <Fab color="primary" size="large">
            <KeyboardArrowUpIcon />
          </Fab>
        </Box>
      </Zoom>
    </Container>
  );
};

export default TransactionHistory;
